import React from "react";
import { useSelector } from "react-redux";
import type { PermissionKey } from "../../../rbac";
import { usePermissions } from "../../../hooks/usePermissions";
import { signedLockedAccess } from "../../../utils/commonHelper";
import { StatusBanner } from "../StatusBanner";

interface SectionBannersProps {
  className?: string;
  requiredPermission: PermissionKey;
}

export const SectionBanners: React.FC<SectionBannersProps> = ({ className, requiredPermission }) => {
  const { hasPermission } = usePermissions();
  const assessmentDetails = useSelector((state: any) => state.patient.detailAssessment);

  const isReadOnly = !hasPermission(requiredPermission);
  const isSignedLocked = !signedLockedAccess(assessmentDetails?.assessmentStage);

  if (!isReadOnly && !isSignedLocked) return null;

  return (
    <div data-testid="section-banners" className={className} style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "16px" }}>
      {isReadOnly && <StatusBanner preset="readOnly" layout="inline" />}
      {isSignedLocked && <StatusBanner preset="signedLocked" layout="inline" />}
    </div>
  );
};
